import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { IPageInfo } from '../../core/interfaces/interface';
import { SEOService } from '../../core/services/seo.service';
import { ToolsJumbotronComponent } from '../shared/components/tools-jumbotron/tools-jumbotron.component';
import { DocumentService } from '../../core/services/document.service';
import { GetDataService } from '../shared/services/get-data.service';
import { filter } from 'rxjs';
import { TranslateModule } from '../../shared/modules/translate/translate.module';

@Component({
  selector: 'app-blog',
  imports: [RouterModule, InlineSVGModule, ToolsJumbotronComponent, TranslateModule],
  templateUrl: './blog-layout.component.html',
  styleUrl: './blog-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogLayoutComponent {
  @Input() latestUpdateDate = true;
  latestUpdate = new Date('2025,05,01');
  pageInfo = signal<IPageInfo>(undefined as any);
  targetSEOKey = undefined;
  constructor(
    private documentService: DocumentService,
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.documentService.goTop();
    });
  }
}
